"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _customData = require("./customData/customData.reducer");

var _recipient = require("./recipient/recipient.reducer");

var _campaigns = require("./campaigns/campaigns.reducer");

var _gift = require("./gift/gift.reducer");

var _templates = require("./templates/templates.reducer");

var _contacts = require("./contacts/contacts.reducer");

var _sendAs = require("./send-as/send-as.reducer");

var _marketplace = require("./marketplace/marketplace.reducer");

var _contactEnrichment = require("./contactEnrichment/contactEnrichment.reducer");

var _address = require("./address");

var _shipping = require("./shipping");

var _postcard = require("./gift/postcard");

var _product = require("./product/product.reducer");

var _invitationType = require("./gift/invitationType/invitationType.reducer");

var _default = (0, _redux.combineReducers)({
  recipient: _recipient.reducer,
  campaigns: _campaigns.campaigns,
  gift: _gift.reducer,
  postcard: _postcard.postcard,
  invitationType: _invitationType.invitationType,
  templates: _templates.reducer,
  contacts: _contacts.reducer,
  sendAs: _sendAs.reducer,
  marketplace: _marketplace.reducer,
  contactEnrichment: _contactEnrichment.reducer,
  placeholders: _customData.customData,
  address: _address.address,
  shipping: _shipping.shipping,
  product: _product.reducer
});

exports.default = _default;